export default __webpack_public_path__ + "static/media/Component 71 – 1.14621b6f.svg";